import React from 'react';

import Tabs from '../Tabs/Tabs';
import { TabShape } from '../Tabs/TabsStateless/TabsStateless';
import Headline from '../Typography/Headline/Headline';
import Divider from '../Divider/Divider';
import Link from '../Link/Link';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Gutter from '../Gutter/Gutter';
import BodyText from '../Typography/BodyText/BodyText';
import { SupportedIconName } from '../../shared/icons';
import Div from '../Element/Div/Div';

import styles from './Login.module.scss';

export type LoginProps = {
  /** Login component heading */
  headingText: string;
  /** Login tabs */
  tabs: TabShape[];
  /** Initial tab selected in login */
  defaultActiveTabIndex?: number;
  /** Additional links on the bottom of the menu */
  additionalLinks?: AdditionalLoginLinkShape[];
};

export interface AdditionalLoginLinkShape {
  /** Additional link target */
  link: string;
  /** Additional link label */
  label: string;
  /** Additional link icon */
  icon?: SupportedIconName;
  /** Additional unique key */
  key?: string;
}

const Login: React.FunctionComponent<LoginProps> = ({
  headingText,
  tabs,
  defaultActiveTabIndex = 0,
  additionalLinks,
}) => {
  return (
    <div data-testid="login" className={styles.login}>
      <Headline size="md" className={styles.login_heading}>
        {headingText}
      </Headline>

      <div className={styles.login_tabs__container}>
        <Tabs defaultActiveTabIndex={defaultActiveTabIndex} tabs={tabs} />
      </div>

      {additionalLinks && (
        <>
          {additionalLinks.map((additionalLink) => {
            return (
              <Div backgroundColor="gray100" key={additionalLink.label}>
                <Divider color="gray300" />

                <Link
                  color="black"
                  hoverColor="black"
                  to={additionalLink.link}
                  data-testid="additional-link"
                >
                  <Flex className={styles.login_additionalLinkContent}>
                    {additionalLink.icon && (
                      <>
                        <Icon
                          name={additionalLink.icon}
                          size="md"
                          color="black"
                        />

                        <Gutter size="xs" />
                      </>
                    )}

                    <BodyText tagName="span">{additionalLink.label}</BodyText>
                  </Flex>
                </Link>
              </Div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Login;
